module.exports = __webpack_public_path__ + "img/capa-hover-livro.149cae7f.png";